export class SpineNormalRenderBase {
    constructor() {
        this.vmeshs = [];
        this.nextBatchIndex = 0;
    }
    clearBatch() {
        for (var i = 0; i < this.vmeshs.length; i++) {
            this.vmeshs[i].clear();
        }
        this.nextBatchIndex = 0;
    }
    nextBatch(material, spineRenderNode) {
        if (this.vmeshs.length == this.nextBatchIndex) {
            let vmesh = this.createMesh(material);
            this.vmeshs.push(vmesh);
            spineRenderNode._renderElements[this.nextBatchIndex++] = vmesh.element;
            vmesh.element.value2DShaderData = spineRenderNode._spriteShaderData;
            return vmesh;
        }
        let vmesh = this.vmeshs[this.nextBatchIndex];
        spineRenderNode._renderElements[this.nextBatchIndex++] = vmesh.element;
        vmesh.material = material;
        return vmesh;
    }
    destroy() {
        for (var i = 0; i < this.vmeshs.length; i++) {
            this.vmeshs[i].destroy();
        }
        this.vmeshs.length = 0;
    }
}
